import { render } from "./AccountSwitcherLoader.vue?vue&type=template&id=4f636133&scoped=true"
import script from "./AccountSwitcherLoader.vue?vue&type=script&lang=js"
export * from "./AccountSwitcherLoader.vue?vue&type=script&lang=js"

import "./AccountSwitcherLoader.vue?vue&type=style&index=0&id=4f636133&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f636133"]])

export default __exports__